import { render, staticRenderFns } from "./ProductFilter.vue?vue&type=template&id=03a61c83&scoped=true&"
import script from "./ProductFilter.vue?vue&type=script&lang=js&"
export * from "./ProductFilter.vue?vue&type=script&lang=js&"
import style0 from "./ProductFilter.vue?vue&type=style&index=0&id=03a61c83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a61c83",
  null
  
)

export default component.exports